var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.551085 8.96704C0.219886 12.3503 1.34596 19.1169 8.49985 19.1169M8.49985 19.1169C15.6537 19.1169 16.78 12.3503 16.449 8.96704M8.49985 19.1169V22.2997M8.49985 22.2997C6.83675 22.333 5.12784 22.4238 4.02901 22.5002C2.28682 22.6212 15 23 12.9714 22.5002C12.1351 22.2968 10.3457 22.2628 8.49985 22.2997ZM9 3C9.33333 3.23362 10.1 3.98078 10.5 5.10043M4.02867 12.2562V5.10043C4 1.99926 7.48407 -1.35823 10.9838 1.71715C12.9714 3.46368 12.9714 13.2261 10.9838 15.2501C9.53692 16.7236 5.07971 17.175 4.04899 12.4463C4.03542 12.384 4.02867 12.3198 4.02867 12.2562Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.74396d3e5f9e78113042072429677b19.svg";
export { ForwardRef as ReactComponent };